<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    스트리밍 관리
                    <el-button class="title_btn" @click="$router.push('streaming/create')" type="primary">등록</el-button>
                </div>
                <div class="list-content">
                    <streaming-list-component :streamingType="'streaming'" :defaultLang="30"></streaming-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import StreamingListComponent from "@/components/streaming/StreamingListComponent";

export default {
    name: 'Streaming',
    mixins: [],
    components: {StreamingListComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>
